import { z } from 'zod';

export const uniqueSet = <T>(arr: T[]): T[] => [...new Set(arr)];

export const mapRecord = <K extends string, V>(
  schema: z.ZodEnum<[K, ...K[]]>,
  fn: (key: K) => V,
): Record<K, V> => {
  const keys = Object.keys(schema.Values) as K[];
  const record: Record<K, V> = {} as Record<K, V>;

  for (const key of keys) {
    record[key] = fn(key);
  }

  return record;
};

export const recordEntries = <K extends string, V>(
  record: Record<K, V>,
): [K, V][] => {
  return Object.entries(record) as [K, V][];
};

export const mapOverRecord = <K extends string, V, R>(
  record: Record<K, V>,
  fn: (key: K, value: V) => R,
): R[] => {
  const keys = Object.keys(record) as K[];
  const result: R[] = [];

  for (const key of keys) {
    result.push(fn(key, record[key]));
  }

  return result;
};

export const mapOverEnum = <T extends string, R>(
  schema: z.ZodEnum<[T, ...T[]]>,
  fn: (key: T) => R,
): R[] => {
  const keys = Object.keys(schema.Values) as T[];
  const result: R[] = [];

  for (const key of keys) {
    result.push(fn(key));
  }

  return result;
};

export const chunkArray = <T>(arr: T[], chunkSize: number): T[][] => {
  const result: T[][] = [];
  let i = 0;

  while (i < arr.length) {
    result.push(arr.slice(i, (i += chunkSize)));
  }

  return result;
};
